import React, { useState } from 'react';

const AgendaModuleFonctionnel = () => {
  const [reunions, setReunions] = useState([
    { id: 1, titre: 'Clôture mensuelle comptable', date: '2026-06-20', heure: '09:00', type: 'reunion', participants: ['Marie B.', 'Sophie D.'], statut: 'planifie', lieu: 'Salle de réunion A' },
    { id: 2, titre: 'Révision budget Q3', date: '2026-06-22', heure: '14:00', type: 'reunion', participants: ['Marie B.', 'DG'], statut: 'planifie', lieu: 'Bureau DG' },
    { id: 3, titre: 'Formation logiciel comptable', date: '2026-06-25', heure: '10:00', type: 'formation', participants: ['Équipe Compta'], statut: 'planifie', lieu: 'Salle formation' }
  ]);

  const [decisions, setDecisions] = useState([
    { id: 1, titre: 'Adoption nouveau logiciel compta', date: '2026-06-10', decideur: 'DG', statut: 'approuve' },
    { id: 2, titre: 'Recrutement assistant comptable', date: '2026-06-12', decideur: 'Chef Compta', statut: 'en_attente' }
  ]);

  const [modalOpen, setModalOpen] = useState('');
  const [formData, setFormData] = useState({});
  const [editingId, setEditingId] = useState(null);

  // Ouvrir modal pour ajouter/modifier
  const openModal = (type, item = null) => {
    setModalOpen(type);
    if (item) {
      setEditingId(item.id);
      setFormData(item);
    } else {
      setEditingId(null);
      setFormData({});
    }
  };

  const closeModal = () => {
    setModalOpen('');
    setEditingId(null);
    setFormData({});
  };

  // CRUD Réunions
  const saveReunion = () => {
    if (!formData.titre || !formData.date || !formData.heure) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    if (editingId) {
      setReunions(reunions.map(r => r.id === editingId ? { ...formData, id: editingId } : r));
    } else {
      setReunions([...reunions, { ...formData, id: Date.now(), statut: 'planifie' }]);
    }
    closeModal();
  };

  const deleteReunion = (id) => {
    if (window.confirm('Supprimer cette réunion ?')) {
      setReunions(reunions.filter(r => r.id !== id));
    }
  };

  // CRUD Décisions
  const saveDecision = () => {
    if (!formData.titre || !formData.date) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }

    if (editingId) {
      setDecisions(decisions.map(d => d.id === editingId ? { ...formData, id: editingId } : d));
    } else {
      setDecisions([...decisions, { ...formData, id: Date.now(), statut: 'en_attente' }]);
    }
    closeModal();
  };

  const deleteDecision = (id) => {
    if (window.confirm('Supprimer cette décision ?')) {
      setDecisions(decisions.filter(d => d.id !== id));
    }
  };

  const styles = {
    container: { padding: '24px', background: '#060d18', minHeight: '100vh', fontFamily: 'DM Sans, sans-serif' },
    header: { marginBottom: 24 },
    title: { fontFamily: 'Cormorant Garamond, serif', fontSize: 28, fontWeight: 600, color: '#fff', marginBottom: 6 },
    subtitle: { fontSize: 13, color: 'rgba(255,255,255,0.4)' },
    section: { marginBottom: 24 },
    sectionTitle: { fontSize: 15, fontWeight: 600, color: '#C9A84C', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 8 },
    card: { background: '#0d1825', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 12, padding: '16px 18px', marginBottom: 12, cursor: 'pointer' },
    cardTitle: { fontSize: 14, fontWeight: 600, color: '#fff', marginBottom: 8 },
    cardMeta: { fontSize: 11, color: '#667', display: 'flex', gap: 16, flexWrap: 'wrap' },
    badge: { fontSize: 10, fontWeight: 600, padding: '3px 10px', borderRadius: 99, display: 'inline-block' },
    btn: { background: '#C9A84C', border: 'none', borderRadius: 8, padding: '9px 18px', color: '#1a1a0d', fontSize: 12, fontWeight: 600, cursor: 'pointer' },
    btnSecondary: { background: 'transparent', border: '1.5px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '8px 16px', color: '#888', fontSize: 11, cursor: 'pointer' },
    btnDanger: { background: 'rgba(239,83,80,0.1)', border: '1px solid rgba(239,83,80,0.3)', borderRadius: 7, padding: '6px 12px', color: '#ef8080', fontSize: 11, cursor: 'pointer' },
    modal: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
    modalContent: { background: '#0d1825', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: 24, width: 500, maxHeight: '85vh', overflowY: 'auto' },
    modalTitle: { fontFamily: 'Cormorant Garamond, serif', fontSize: 22, fontWeight: 600, color: '#fff', marginBottom: 20 },
    field: { marginBottom: 14 },
    label: { fontSize: 11, fontWeight: 600, color: '#8a9bb0', marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: 0.5 },
    input: { width: '100%', background: 'rgba(255,255,255,0.05)', border: '1.5px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 12px', color: '#fff', fontSize: 13, outline: 'none' },
    textarea: { width: '100%', background: 'rgba(255,255,255,0.05)', border: '1.5px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '10px 12px', color: '#fff', fontSize: 13, outline: 'none', minHeight: 80, resize: 'vertical' }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.title}>📅 Agenda & Planning</div>
        <div style={styles.subtitle}>Gestion des réunions, rendez-vous et décisions</div>
      </div>

      {/* RÉUNIONS */}
      <div style={styles.section}>
        <div style={styles.sectionTitle}>
          <span>📅 Réunions & Rendez-vous</span>
          <button style={{...styles.btn, marginLeft: 'auto'}} onClick={() => openModal('reunion')}>
            + Nouvelle réunion
          </button>
        </div>

        {reunions.map(reunion => (
          <div key={reunion.id} style={styles.card}>
            <div style={styles.cardTitle}>{reunion.titre}</div>
            <div style={styles.cardMeta}>
              <span>📅 {reunion.date}</span>
              <span>🕐 {reunion.heure}</span>
              <span>📍 {reunion.lieu}</span>
              <span>👥 {reunion.participants?.join(', ')}</span>
              <span style={{
                ...styles.badge,
                background: reunion.statut === 'planifie' ? 'rgba(66,165,245,0.15)' : 'rgba(76,175,80,0.15)',
                color: reunion.statut === 'planifie' ? '#64b5f6' : '#66bb6a'
              }}>
                {reunion.statut === 'planifie' ? '⏳ Planifié' : '✅ Terminé'}
              </span>
            </div>
            <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
              <button style={styles.btnSecondary} onClick={() => openModal('reunion', reunion)}>
                ✏️ Modifier
              </button>
              <button style={styles.btnDanger} onClick={() => deleteReunion(reunion.id)}>
                🗑️ Supprimer
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* DÉCISIONS */}
      <div style={styles.section}>
        <div style={styles.sectionTitle}>
          <span>✅ Décisions & Validations</span>
          <button style={{...styles.btn, marginLeft: 'auto'}} onClick={() => openModal('decision')}>
            + Nouvelle décision
          </button>
        </div>

        {decisions.map(decision => (
          <div key={decision.id} style={styles.card}>
            <div style={styles.cardTitle}>{decision.titre}</div>
            <div style={styles.cardMeta}>
              <span>📅 {decision.date}</span>
              <span>👤 {decision.decideur}</span>
              <span style={{
                ...styles.badge,
                background: decision.statut === 'approuve' ? 'rgba(76,175,80,0.15)' : 'rgba(251,140,0,0.15)',
                color: decision.statut === 'approuve' ? '#66bb6a' : '#ffb74d'
              }}>
                {decision.statut === 'approuve' ? '✅ Approuvé' : '⏳ En attente'}
              </span>
            </div>
            <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
              <button style={styles.btnSecondary} onClick={() => openModal('decision', decision)}>
                ✏️ Modifier
              </button>
              <button style={styles.btnDanger} onClick={() => deleteDecision(decision.id)}>
                🗑️ Supprimer
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* MODAL RÉUNION */}
      {modalOpen === 'reunion' && (
        <div style={styles.modal} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalTitle}>
              {editingId ? '✏️ Modifier la réunion' : '➕ Nouvelle réunion'}
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Titre *</label>
              <input
                style={styles.input}
                value={formData.titre || ''}
                onChange={(e) => setFormData({...formData, titre: e.target.value})}
                placeholder="Ex: Clôture mensuelle comptable"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <div style={styles.field}>
                <label style={styles.label}>Date *</label>
                <input
                  type="date"
                  style={styles.input}
                  value={formData.date || ''}
                  onChange={(e) => setFormData({...formData, date: e.target.value})}
                />
              </div>
              <div style={styles.field}>
                <label style={styles.label}>Heure *</label>
                <input
                  type="time"
                  style={styles.input}
                  value={formData.heure || ''}
                  onChange={(e) => setFormData({...formData, heure: e.target.value})}
                />
              </div>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Type</label>
              <select
                style={styles.input}
                value={formData.type || 'reunion'}
                onChange={(e) => setFormData({...formData, type: e.target.value})}
              >
                <option value="reunion">Réunion</option>
                <option value="formation">Formation</option>
                <option value="rendez-vous">Rendez-vous</option>
              </select>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Lieu</label>
              <input
                style={styles.input}
                value={formData.lieu || ''}
                onChange={(e) => setFormData({...formData, lieu: e.target.value})}
                placeholder="Ex: Salle de réunion A"
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Participants (séparés par des virgules)</label>
              <input
                style={styles.input}
                value={formData.participants?.join(', ') || ''}
                onChange={(e) => setFormData({...formData, participants: e.target.value.split(',').map(p => p.trim())})}
                placeholder="Ex: Marie B., Sophie D., DG"
              />
            </div>

            <div style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button style={styles.btnSecondary} onClick={closeModal}>Annuler</button>
              <button style={styles.btn} onClick={saveReunion}>
                {editingId ? '💾 Enregistrer' : '➕ Créer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DÉCISION */}
      {modalOpen === 'decision' && (
        <div style={styles.modal} onClick={closeModal}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalTitle}>
              {editingId ? '✏️ Modifier la décision' : '➕ Nouvelle décision'}
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Titre *</label>
              <input
                style={styles.input}
                value={formData.titre || ''}
                onChange={(e) => setFormData({...formData, titre: e.target.value})}
                placeholder="Ex: Adoption nouveau logiciel compta"
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Date *</label>
              <input
                type="date"
                style={styles.input}
                value={formData.date || ''}
                onChange={(e) => setFormData({...formData, date: e.target.value})}
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Décideur</label>
              <input
                style={styles.input}
                value={formData.decideur || ''}
                onChange={(e) => setFormData({...formData, decideur: e.target.value})}
                placeholder="Ex: DG, Chef Compta"
              />
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Statut</label>
              <select
                style={styles.input}
                value={formData.statut || 'en_attente'}
                onChange={(e) => setFormData({...formData, statut: e.target.value})}
              >
                <option value="en_attente">En attente</option>
                <option value="approuve">Approuvé</option>
                <option value="refuse">Refusé</option>
              </select>
            </div>

            <div style={{ marginTop: 20, display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button style={styles.btnSecondary} onClick={closeModal}>Annuler</button>
              <button style={styles.btn} onClick={saveDecision}>
                {editingId ? '💾 Enregistrer' : '➕ Créer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgendaModuleFonctionnel;
